const scrapingTagEditorFormInitialValues = data => data

export default scrapingTagEditorFormInitialValues
